export default "__VITE_ASSET__DaFgamdR__"